// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"MobileBreadcrumb_breadcrumbContainer__D3IY6","titleContainer":"MobileBreadcrumb_titleContainer__BFSGC","title":"MobileBreadcrumb_title__K_NWF"};